<template>
  <v-form ref="form" v-model="valid" @submit.prevent="submit">
    <v-card>
      <v-card-title>
        <span class="headline">Add operator</span>
      </v-card-title>
      <v-card-text>
        <v-text-field name="operatorname" label="Name" :rules="nameRules" :disabled="isSaving" v-model="name"/>
      </v-card-text>
      <v-card-actions>
        <v-btn depressed :disabled="!valid" :loading="isSaving" color="primary" type="submit">Save</v-btn>
        <v-btn text @click="abort" color="primary">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
export default {
  data: () => ({
    name: null,
    valid: false,
    nameRules: [v => (v != null && v !== '') || 'Name is required']
  }),
  computed: {
    isSaving () {
      return this.$store.getters.isLoadingFor('operators.create');
    }
  },
  methods: {
    submit () {
      if (this.valid)
        this.$emit('submit', {
          name: this.name,
          description: null
        });
    },
    abort () {
      this.$emit('abort');
    },
    reset () {
      this.$refs.form.reset();
    }
  }
}
</script>
